import Vue from 'vue';

const linkKeyMatcher = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)+(\[.*\])?))/g;
const linkKeyPrefixMatcher = /^@(?:\.([a-zA-Z]+))?:/;
const bracketsMatcher = /[()]/g;
const linkParamsMatcher = /\[(.+?)\]/g;
const defaultModifiers = {
  'upper': str => str.toLocaleUpperCase(),
  'lower': str => str.toLocaleLowerCase(),
  'capitalize': str => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`
};
Vue.prototype.$tcc = function (key, count, params) {
  const messages = this.$i18n._getMessages()[this.$i18n.locale];
  let ret = this.$i18n._path.getPathValue(messages, key) || messages[key];

  if (!ret) {
    return this.$tc(key, count, params);
  }

  const matches = ret.match(linkKeyMatcher);
  for (const link of matches) {
    const [linkPrefix, formatterName] = link.match(linkKeyPrefixMatcher);
    let linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');
    let params = [];
    const paramsMatches = linkPlaceholder.match(linkParamsMatcher);
    if (paramsMatches && paramsMatches[0]) {
      params = JSON.parse(paramsMatches[0]);
      linkPlaceholder = linkPlaceholder.replace(linkParamsMatcher, '');
    }
    let translated = Reflect.apply(this.$tc, this, [linkPlaceholder, ...params]);
    if (!translated) {
      continue;
    }
    if (Reflect.has(this.$i18n._modifiers, formatterName)) {
      translated = this.$i18n._modifiers[formatterName](translated);
    } else if (Reflect.has(defaultModifiers, formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }
    ret = ret.replace(link, translated);
  }
  return ret;
};
